import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'

import Select from '../form/Select'
import { sortBy } from '../../utils/helpers'

@observer
class ComparisonSelector extends Component {
    constructor(props) {
        super(props)

        this.wrapperRef = React.createRef()
        this.handleClickOutside = this.handleClickOutside.bind(this)
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside(event) {
        const { toggleShowComparison } = this.props
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            toggleShowComparison()
        }
    }

    render() {
        const { dashStore } = this.props
        const {
            years,
            changeYears,
            benchmarks,
            changeBenchmarks,
            benchmarkLabels,
            benchmarkPeriods,
            benchmarkPeriod,
            changeBenchmarkPeriod,
        } = dashStore

        return (
            <div className="dashboardComparisonSelector" ref={this.wrapperRef}>
                <div className="controls">
                    <Fragment>
                        <Select
                            classNamePrefix="dropdown"
                            className="exploriDropdown"
                            name="benchmarks-select"
                            value={
                                sortBy(
                                    Array.from(benchmarks)
                                        .filter((a) => !!a[1])
                                        .map(([y]) => ({ label: benchmarkLabels[y], value: y })),
                                    'value',
                                )
                            }
                            options={
                                sortBy(
                                    Array.from(benchmarks)
                                        .map(([y]) => ({ label: benchmarkLabels[y], value: y })),
                                    'value',
                                )
                            }
                            onBlur={changeBenchmarks}
                            style={{ width: '450px' }}
                            isMulti
                            label="Benchmarks:"
                            blurOnClear
                        />
                        <Select
                            classNamePrefix="dropdown"
                            className="exploriDropdown"
                            name="benchmarkPeriods"
                            defaultValue={benchmarkPeriod}
                            options={benchmarkPeriods}
                            onBlur={changeBenchmarkPeriod}
                            style={{ width: '450px' }}
                            label="Benchmark Period:"
                        />
                    </Fragment>
                    <Select
                        classNamePrefix="dropdown"
                        className="exploriDropdown"
                        value={
                            sortBy(
                                Array.from(years)
                                    .filter((a) => !!a[1] && a[0] >= 1900)
                                    .map(([y]) => ({ label: y, value: y })),
                                'value',
                            )
                        }
                        options={
                            sortBy(
                                Array.from(years)
                                    .map(([y]) => ({ label: y, value: y }))
                                    .filter((year) => (year.value >= 1900)),
                                'value',
                            )
                        }
                        onBlur={changeYears}
                        style={{ width: '450px' }}
                        isMulti
                        label="Years:"
                        blurOnClear
                    />
                </div>
            </div>
        )
    }
}

export default ComparisonSelector
